import { useEffect, useState } from 'react';

export function AlertBanner({ type, message }: { type: 'error' | 'success'; message: string }) {
  const isError = type === 'error';
  return (
    <div className={`flex items-start gap-2.5 rounded-md border p-3 text-sm ${
      isError
        ? 'border-danger/30 bg-danger-light text-danger-dark'
        : 'border-success/30 bg-success-light text-success-dark'
    }`}>
      {isError ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="mt-0.5 h-4 w-4 shrink-0">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clipRule="evenodd" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="mt-0.5 h-4 w-4 shrink-0">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
        </svg>
      )}
      <span>{message}</span>
    </div>
  );
}

export function useAutoHideMessage(value: string | null, delay = 3000): string | null {
  const [visible, setVisible] = useState(value);
  useEffect(() => {
    setVisible(value);
    if (!value) return;
    const timer = setTimeout(() => setVisible(null), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return visible;
}
